import a from "deepmerge";
import { authService as c } from "./service.es.js";
import { create as i } from "./external/zustand/esm/react.es.js";
const U = {
  ...c.getAnonymous(),
  status: void 0
}, r = i()(() => U), m = (e) => {
  r.setState(e || c.getAnonymous());
}, b = (e) => {
  r.setState((t) => ({ ...t, ...e }));
}, l = (e) => {
  r.setState((t) => ({
    ...t,
    currentUser: e,
    userId: e == null ? void 0 : e.id
  }));
}, h = (e) => {
  e && r.setState((t) => {
    if (!t.currentUser) return t;
    const s = a(t.currentUser, e);
    return {
      ...t,
      currentUser: s,
      userId: e.id || t.userId
    };
  });
}, I = (e) => {
  r.setState((t) => t.currentUser ? {
    ...t,
    currentUser: {
      ...t.currentUser,
      subscriptionPlan: e
    }
  } : t);
}, A = (e) => {
  e && r.setState((t) => {
    if (!t.currentUser) return t;
    const s = t.currentUser.lobbies || [];
    let n = !1;
    const u = s.map((o) => o.lobbyID === e.lobbyID ? (n = !0, e) : o);
    return n || u.push(e), {
      ...t,
      currentUser: {
        ...t.currentUser,
        lobbies: u
      }
    };
  });
};
export {
  U as authInitialState,
  m as setAuthState,
  l as setCurrentUser,
  I as setSubscriptionPlan,
  b as updateAuthState,
  h as updateCurrentUser,
  A as upsertCurrentUserLobby,
  r as useAuthStore
};
